// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/logo/our-village-logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-auth-wrapper {
  background-color: #fff;
}
.app-auth-wrapper .auth-wrap-left-content {
  position: relative;
}
.app-auth-wrapper a:focus {
  text-decoration: underline !important;
}
.app-auth-wrapper .main-image {
  position: absolute;
  width: 161px;
  height: 234px;
  top: 0px;
  left: 40px;
}

.bv-forget-wrap .responsiveness {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-wrap-right-content {
  height: 100%;
  display: grid;
}

.auth-wrap-right-content {
  height: 100%;
  display: grid;
  position: relative;
  background-color: #fff;
}
.auth-wrap-right-content::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.1;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.auth-wrap-right-content > * {
  position: relative;
  z-index: 2;
}

@media only screen and (max-width: 792px) and (min-width: 768px) {
  .bv-forget-wrap .responsiveness {
    flex-direction: column;
  }
}
@media only screen and (max-width: 578px) {
  .auth-wrap-right-content {
    margin: 0 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Authentication/Styles.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;AAAI;EACI,kBAAA;AAER;AAIQ;EACI,qCAAA;AAFZ;AAKI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;AAHR;;AAQI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AALR;;AASA;EAEI,YAAA;EACA,aAAA;AAPJ;;AAUA;EAEI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AARJ;AAWI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,gCAAA;EACA,UAAA;AATR;AAaI;EACI,kBAAA;EACA,UAAA;AAXR;;AAeA;EAEQ;IACI,sBAAA;EAbV;AACF;AAiBA;EACI;IACI,cAAA;EAfN;AACF","sourcesContent":[".app-auth-wrapper {\n    background-color: #fff;\n    .auth-wrap-left-content {\n        position: relative;\n    }\n    .auth-wrap-right-content {\n        // css here frt right side\n    }\n    a {\n        &:focus {\n            text-decoration: underline !important;\n        }\n    }\n    .main-image {\n        position: absolute;\n        width: 161px;\n        height: 234px;\n        top: 0px;\n        left: 40px;\n    }\n}\n\n.bv-forget-wrap {\n    .responsiveness {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.auth-wrap-right-content {\n    // css here frt right side\n    height: 100%;\n    display: grid;\n}\n\n.auth-wrap-right-content {\n    // CSS for the right side\n    height: 100%;\n    display: grid;\n    position: relative;\n    background-color: #fff; // Adjust background color if needed\n\n    // Add background logo\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 500px; // Adjust size as needed\n        height: 500px; // Adjust size as needed\n        background-image: url(\"../../assets/images/logo/our-village-logo.svg\");\n        background-repeat: no-repeat;\n        background-size: contain;\n        opacity: 0.1; // Adjust opacity as needed\n        transform: translate(-50%, -50%);\n        z-index: 1;\n    }\n\n    // Ensure the content is above the background\n    > * {\n        position: relative;\n        z-index: 2;\n    }\n}\n\n@media only screen and (max-width: 792px) and (min-width: 768px) {\n    .bv-forget-wrap {\n        .responsiveness {\n            flex-direction: column;\n        }\n    }\n}\n\n@media only screen and (max-width: 578px) {\n    .auth-wrap-right-content {\n        margin: 0 3rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
